import React, { useState } from "react";
import "./ShortCommand.css";

export default function ShortCommand(props) {
  return (
    <div
      className="shortContainer"
      style={{
        maxWidth: props.width,
        minWidth: props.width,
        maxHeight: props.height,
        minHeight: props.height,
      }}
    >
      <svg
        onClick={props.onClickShortCommand}
        className="shortCommand"
        style={{
          maxWidth: props.width,
          minWidth: props.width,
          maxHeight: props.height,
          minHeight: props.height,
        }}
      >
        <line x1="1" y1="4" x2="7" y2="4" />
        {props.reduced && <line x1="4" y1="1" x2="4" y2="7" />}
      </svg>
    </div>
  );
}
